import React, { Component } from 'react'
import { Row, Col } from 'reactstrap'
import { ClassList } from './AssignBlockComponents'

class AssignBlock extends Component {

  render() {
    const { students, record } = this.props
    
    return (
      <Col xs='12'>
      <span className="card-action-separator"></span>
        
        <h6>Assign Students to Class</h6>
        <Row>
        <Col xs='12' md='6'>
          <ClassList notInClass={true} students={students} record={record} />
          </Col>
          <Col xs='12' md='6'>
            <ClassList inClass={true} students={students} record={record} />
        </Col>
        </Row>
      </Col>
    )
  }
}

export default AssignBlock


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/AssignBlock.js